import { put, select, takeEvery } from 'redux-saga/effects'
import { initScenario, restartScenario } from '../scenario-slice'
import { nextStep, previousStep, gotoStep } from '../step-slice'
import { addAnswer } from '../answers-slice'
import { setProgress } from '../progress-slice'
import { selectMilestones, selectCurrentStepId } from '../selectors'
import { StepId } from '../interfaces'

export function* progressSaga() {
  yield takeEvery(initScenario.type, updateProgressValue)
  yield takeEvery(gotoStep.type, updateProgressValue)
  yield takeEvery(restartScenario.type, updateProgressValue)
  yield takeEvery(addAnswer.type, updateProgressValue)
  yield takeEvery(nextStep.type, updateProgressValue)
  yield takeEvery(previousStep.type, updateProgressValue)
}

function* updateProgressValue() {
  const milestones: string[] = yield select(selectMilestones)
  const currentStepId: StepId = yield select(selectCurrentStepId)

  if (milestones) {
    const currentProgressValue: number = milestones.indexOf(currentStepId) + 1
    if (currentProgressValue > 0) {
      yield put(setProgress(Math.floor((currentProgressValue / milestones.length) * 100)))
    }
  }
}
